import Cookies from "js-cookie";
import axios from "../../../util/axios";

export async function getDoctors() {
  try {
    const headers = {
      Authorization: `Bearer ${Cookies.get("token")}`,
    };
    const { data } = await axios.get(
      `admin/v1/clinic/${Cookies.get("clinic_id")}/doctors`,
      {
        headers,
      },
    );
    return data.doctors;
  } catch (error) {
    console.error("Error fetching doctors:", error);
    throw error;
  }
}
